import React from "react";
import { Link } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import Wallet from "../../../Components/User/Wallet";
import Setting from "../../../Components/User/Setting";
import UserModal from "../../../Components/User/Stat/Modal";
import storage from "../../../../Storage";
import { defaultAvatar, Event } from "../../../../Helper";
import PrivateMessage from "./../PrivateMessage";
import Logout from "./../../Auth/Logout";
import Affiliate from "../../Affiliate";

class User extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            level: 1,
            name: storage.getKey('name'),
            avatar: storage.getKey('avatar') !== 'false' ? storage.getKey('avatar') : defaultAvatar,
            showSidebar: false
        };
        this.toggleSidebar = this.toggleSidebar.bind(this);
    }

    componentDidMount() {
        Event.on('toggle_user_sidebar', this.toggleSidebar);
        Event.on('open_user_sidebar', this.openSidebar);
    }

    componentWillUnmount() {
        Event.removeListener('toggle_user_sidebar', this.toggleSidebar);
        Event.removeListener('open_user_sidebar', this.openSidebar);
    }

    openSidebar = () => {
        this.setState({ showSidebar: true });
    }

    toggleSidebar() {
        this.setState({ showSidebar: !this.state.showSidebar });
    }

    render() {
        const { t } = this.props;
        const { showSidebar } = this.state;

        return (
            <div className="user-dropdown-container">
                <div onClick={this.toggleSidebar} className="nav-user-toggle cursor-pointer d-flex align-items-center mt-1 hidden-sm">
                    <div className="profile-avator letter-avatar">
                        {this.state.name ? this.state.name.charAt(0).toUpperCase() : '?'}
                    </div>
                    <span className="ml-1 nav-user-name">
                        <span className='hidden-sm'>{this.state.name}</span>
                        <span className="caret ml-1" style={{ color: '#f26722' }}></span>
                    </span>
                </div>

                {/* Sidebar Overlay */}
                <div
                    className={`sidebar-overlay ${showSidebar ? 'show' : ''}`}
                    onClick={this.toggleSidebar}
                ></div>

                {/* Collapsible Sidebar */}
                <div className={`user-sidebar ${showSidebar ? 'show' : ''}`}>
                    <div className="sidebar-close-btn" onClick={this.toggleSidebar}>
                        <i className="mdi mdi-close" />
                    </div>

                    <UserInfo
                        level={this.state.level}
                        name={this.state.name}
                        avatar={this.state.avatar}
                        t={t}
                    />

                    <div className="user-links">
                        <div className="sidebar-item" onClick={this.toggleSidebar}>
                            <i className="mdi mdi-wallet" />
                            <Wallet t={t} sidebar={true} />
                        </div>

                        <div className="sidebar-item mt-2" onClick={this.toggleSidebar}>
                            <i className="mdi mdi-cogs" />
                            <Setting t={t} sidebar={true} />
                        </div>

                        <div className="sidebar-item mt-2" onClick={this.toggleSidebar}>
                            <i className="mdi mdi-account-group" />
                            <Affiliate t={t} sidebar={true} />
                        </div>

                        <div className="sidebar-item mt-2" onClick={this.toggleSidebar}>
                            <i className="mdi mdi-logout" />
                            <Logout t={t} sidebar={true} />
                        </div>
                    </div>


                    <div className="sidebar-footer">
                        <div>FastaFX Premium Trading Experience</div>
                        <div className="opacity-50 mt-1">© 2026 FastaFX. All rights reserved.</div>
                    </div>
                </div>
            </div>
        );
    }
}

class UserInfo extends React.Component {
    render() {
        const { name } = this.props;
        let phone = storage.getKey('email');
        return (
            <div className="user-bar">
                <div className="profile-avator-large mb-3 letter-avatar">
                    {name ? name.charAt(0).toUpperCase() : '?'}
                </div>
                <div className="user-name-text">{name} <br /> <span style={{ fontSize: '12px' }}>{phone}</span> </div>
                <div className="badge badge-soft-success mt-1">
                    <i className="mdi mdi-check-decagram mr-1" />
                    Verified User
                </div>
            </div>
        );
    }
}

export default User;